import { useEffect, useRef } from 'react'

import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

export const WEEKLY_POSTING_STREAK_QUERY = graphql(/* GraphQL */ `
  query WeeklyPostingStreak($input: WeeklyPostingStreakInput!) {
    weeklyPostingStreak(input: $input) {
      count
      status
      periodsAhead
      previousCount
      longestCount
      userStreakState
      percentileRank
    }
  }
`)

// Export the query result type for use in other components
export type WeeklyPostingStreakData = ResultOf<
  typeof WEEKLY_POSTING_STREAK_QUERY
>

// Extract the StreakStatus type from the query result
type StreakStatus = NonNullable<
  WeeklyPostingStreakData['weeklyPostingStreak']
>['status']

export const useWeeklyPostingStreak = (
  organizationId: string | undefined,
): useQuery.Result<
  WeeklyPostingStreakData,
  VariablesOf<typeof WEEKLY_POSTING_STREAK_QUERY>,
  'empty' | 'complete' | 'streaming'
> => {
  return useQuery(WEEKLY_POSTING_STREAK_QUERY, {
    variables: {
      input: {
        organizationId: organizationId ?? '',
      },
    },
    skip: !organizationId,
  })
}

export const usePreviousStreakStatus = (
  status?: StreakStatus,
): StreakStatus | undefined => {
  const ref = useRef<StreakStatus | undefined>(undefined)
  useEffect(() => {
    ref.current = status
  }, [status])
  return ref.current
}
